// Generated from design/tokens/brand.json. Run node design/scripts/generate-tokens.mjs; do not edit.
export const playTokens = {
  "theme": {
    "palette": {
      "color-1": "#FFF000",
      "color-2": "#EC75B2",
      "color-3": "#9BCF91"
    },
    "neutral": {
      "neutral-1": "#FFFFFF",
      "neutral-2": "#F6F7F3",
      "neutral-3": "#EDEFEA",
      "neutral-4": "#D9DCD5",
      "neutral-5": "#C0C4BB",
      "neutral-6": "#9B9F95",
      "neutral-7": "#5E625B",
      "neutral-8": "#3E413C",
      "neutral-9": "#252824",
      "neutral-10": "#171916"
    },
    "status": {
      "success": "#275C36",
      "warning": "#80500A",
      "error": "#A72E36"
    },
    "translucency": 20,
    "primary-foreground": "neutral-10",
    "fonts": {
      "ui": {
        "family": "\"Open Runde\", -apple-system, BlinkMacSystemFont, sans-serif",
        "weights": {
          "regular": 400,
          "medium": 700,
          "heavy": 800
        }
      },
      "brand": {
        "family": "\"Open Runde\", -apple-system, BlinkMacSystemFont, sans-serif",
        "weights": {
          "regular": 400,
          "medium": 700,
          "heavy": 800
        }
      },
      "editorial": {
        "family": "\"Open Runde\", -apple-system, BlinkMacSystemFont, sans-serif",
        "weights": {
          "regular": 400,
          "medium": 700,
          "heavy": 800
        }
      },
      "data": {
        "family": "\"Open Runde\", -apple-system, BlinkMacSystemFont, sans-serif",
        "weights": {
          "regular": 400,
          "medium": 700,
          "heavy": 800
        }
      }
    },
    "text": {
      "xxs": {
        "size": "10px",
        "line": "14px",
        "letter-spacing": "-0.04em"
      },
      "xs": {
        "size": "12px",
        "line": "16px",
        "letter-spacing": "-0.04em"
      },
      "s": {
        "size": "14px",
        "line": "20px",
        "letter-spacing": "-0.04em"
      },
      "m": {
        "size": "16px",
        "line": "24px",
        "letter-spacing": "-0.04em"
      },
      "l": {
        "size": "24px",
        "line": "32px",
        "letter-spacing": "-0.04em"
      },
      "xl": {
        "size": "36px",
        "line": "40px",
        "letter-spacing": "-0.04em"
      },
      "xxl": {
        "size": "48px",
        "line": "52px",
        "letter-spacing": "-0.04em"
      }
    },
    "space": {
      "zero": "0px",
      "xxs": "4px",
      "xs": "8px",
      "s": "12px",
      "m": "16px",
      "l": "24px",
      "xl": "32px",
      "xxl": "48px"
    },
    "radius": {
      "zero": "0px",
      "xs": "8px",
      "s": "16px",
      "m": "22px",
      "l": "28px",
      "xl": "40px",
      "full": "9999px"
    },
    "border": {
      "none": "0px",
      "s": "0px",
      "m": "0px",
      "l": "0px"
    },
    "border-default-color": "#D9DCD533",
    "shadow": {
      "none": "none",
      "s": "0px 2px 4px 0px #17191600",
      "m": "0px 2px 6px 0px #1719160D, 0px 8px 24px 0px #17191613",
      "l": "0px 16px 48px 0px #17191600"
    },
    "motion": {
      "duration": "200ms",
      "easing": "cubic-bezier(0.16, 1, 0.3, 1)",
      "large-duration": "360ms",
      "large-easing": "cubic-bezier(0.22, 1, 0.36, 1)",
      "popup-scale": "0.96",
      "press-distance": "1px"
    }
  },
  "color": {
    "canvas": "#FFFFFF",
    "surface": "#F6F7F3",
    "surface-muted": "#EDEFEA",
    "surface-pink": "#FBE3F0",
    "surface-green": "#EBF5E9",
    "ink": "#171916",
    "muted": "#5E625B",
    "border": "#D9DCD5",
    "border-strong": "#8A8E85",
    "action": "#FFF000",
    "selected": "#EC75B2",
    "live": "#9BCF91",
    "orange": "#F3AE53",
    "grey-blue": "#8EA8BF",
    "success": "#275C36",
    "warning": "#80500A",
    "warning-bg": "#E6DCCE",
    "danger": "#A72E36",
    "danger-bg": "#EDD5D7"
  },
  "terrain": {
    "grass": "#B5D69B",
    "grass-deep": "#7FAE6E",
    "veld": "#D8C98A",
    "earth": "#B98B5E",
    "sand": "#E8DDC2",
    "rock": "#9B9F95",
    "rock-deep": "#5E625B",
    "water": "#7FB6D9",
    "water-deep": "#4F8FBF",
    "tree": "#4F8A5B",
    "tree-light": "#6FA866",
    "trunk": "#7A5A3A",
    "sky": "#CFE2F1"
  },
  "landscape": {
    "grass": "#657A3A",
    "grass-dry": "#9A8A50",
    "heath": "#6F6448",
    "moss": "#3E5530",
    "forest": "#43532F",
    "farmland": "#988E55",
    "built": "#B3A891",
    "earth": "#6B4F37",
    "scree": "#9A9081",
    "rock": "#7A7D7E",
    "rock-deep": "#4B525C",
    "snow": "#EDF0F3",
    "water-deep": "#1E3A4C",
    "water-shallow": "#3C6A72",
    "sand": "#C9B48C",
    "lawn": "#5E8A3A",
    "vine": "#5B6B2E",
    "road": "#77706A",
    "trail": "#CDB48A",
    "scrub": "#5E6A4C",
    "wall": "#D9CFBC",
    "roof": "#9A5B45",
    "roof-slate": "#5C6064",
    "roof-pale": "#A9A396",
    "conifer": "#34523A",
    "birch-leaf": "#71833A",
    "birch-bark": "#D6D0C2",
    "shrub": "#4D5C31",
    "grass-tuft": "#7D8243",
    "trunk": "#4A3626",
    "sun": "#FFC587",
    "sky-fill": "#7A93BE",
    "bounce": "#6A533F",
    "haze": "#8F93A3",
    "sky-zenith": "#2C4870",
    "sky-horizon": "#E3AE88",
    "sun-glow": "#FFD49C"
  },
  "course": {
    "1": "#FFF000",
    "2": "#EC75B2",
    "3": "#9BCF91",
    "4": "#F3AE53",
    "5": "#8EA8BF"
  },
  "typography": {
    "sans": "\"Open Runde\", -apple-system, BlinkMacSystemFont, sans-serif",
    "display": "\"Open Runde\", -apple-system, BlinkMacSystemFont, sans-serif",
    "condensed": "\"Open Runde\", -apple-system, BlinkMacSystemFont, sans-serif",
    "mono": "ui-monospace, SFMono-Regular, Menlo, monospace"
  },
  "spacing": {
    "1": "4px",
    "2": "8px",
    "3": "12px",
    "4": "16px",
    "6": "24px",
    "8": "32px",
    "12": "48px",
    "16": "64px"
  },
  "radius": {
    "xs": "8px",
    "sm": "16px",
    "md": "22px",
    "lg": "28px",
    "xl": "40px",
    "pill": "9999px"
  },
  "layout": {
    "control-height": "44px",
    "control-height-compact": "36px",
    "avatar-size-large": "96px",
    "avatar-size-xlarge": "120px",
    "video-ratio": "16 / 9",
    "content-max": "1440px"
  },
  "motion": {
    "fast": "200ms",
    "normal": "360ms",
    "ease": "cubic-bezier(0.16, 1, 0.3, 1)",
    "ease-large": "cubic-bezier(0.22, 1, 0.36, 1)"
  },
  "elevation": {
    "press": "0px 2px 4px 0px #17191600",
    "overlay": "0px 2px 6px 0px #1719160D, 0px 8px 24px 0px #17191613"
  }
} as const
